import { Box, Stack, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { format, formatDistanceToNow, parseJSON } from 'date-fns'

import { DATE_TIME_FORMAT } from 'constants/index'
import { EtaSource } from 'generated/graphql'

import { getEtaSourceMeta } from './etaSourceMeta'

interface IProps {
  source?: EtaSource | null
  lastUpdatedAt?: string | null
  hasValue: boolean
}

export const EtaSourceTooltipContent = ({ source, lastUpdatedAt, hasValue }: IProps) => {
  const { label, description, Icon, getColor } = getEtaSourceMeta(source, hasValue)
  const updatedAt = lastUpdatedAt ? parseJSON(lastUpdatedAt) : null

  return (
    <Box sx={{ width: 'max-content', maxWidth: 256, px: 1.5, py: 1.25 }}>
      <Stack direction='row' spacing={1} alignItems='center'>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 22,
            height: 22,
            borderRadius: '50%',
            flexShrink: 0,
            color: getColor,
            bgcolor: (theme) => alpha(getColor(theme), 0.12),
          }}>
          <Icon sx={{ fontSize: 14 }} />
        </Box>
        <Typography variant='subtitle2' fontWeight={700} lineHeight={1.3}>
          {label}
        </Typography>
      </Stack>
      <Typography
        variant='caption'
        color='text.secondary'
        display='block'
        lineHeight={1.45}
        sx={{ mt: 0.75 }}>
        {description}
      </Typography>

      {updatedAt && (
        <Box sx={{ mt: 1, pt: 1, borderTop: 1, borderColor: 'divider' }}>
          <Typography variant='caption' color='text.secondary' display='block' lineHeight={1.4}>
            Last recalculated
          </Typography>
          <Typography variant='caption' fontWeight={600} display='block' lineHeight={1.4}>
            {format(updatedAt, DATE_TIME_FORMAT)}
            <Typography
              component='span'
              variant='caption'
              color='text.secondary'
              fontWeight={400}
              sx={{ ml: 0.75, whiteSpace: 'nowrap' }}>
              ({formatDistanceToNow(updatedAt, { addSuffix: true })})
            </Typography>
          </Typography>
        </Box>
      )}
    </Box>
  )
}
